import componentSlider from "../../common/componentSlider.js";

export default (el) => {
  if (document.querySelector(".is-page-editor")) {
    return;
  }

  document
    .querySelectorAll(".js-simple-content-listing-carousel")
    .forEach((el) => {
      const breakpoint = 681;
      // **** responsive will destroy the slider, but doesn't recreate it (August 2020) **** //
      const config = {
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: breakpoint,
            settings: "unslick",
          },
        ],
      };

      let activeSlider = window.innerWidth < breakpoint;
      const sliderControls = componentSlider(el, config);

      window.addEventListener("resize", () => {
        if (!activeSlider && window.innerWidth < breakpoint) {
          activeSlider = true;
          sliderControls.createSlider();
        }

        if (activeSlider && window.innerWidth >= breakpoint) {
          activeSlider = false;
        }
      });
    });
};
